<template>
  <div
    class="search"
    :class="{ error: searchError }"
    v-click-outside="closeSearch"
  >
    <WellsSearch
      v-if="type === 'wells'"
      v-model="searchTerm"
      v-on:focus="searchClosed = !filteredResults.length"
    />
    <div
      class="search__results"
      v-if="!searchClosed && !searchError && searchTerm.length > 2"
      :class="'results-' + filteredResults.length"
    >
      <WellsSearchResult
        v-for="product in filteredResults"
        :key="product.ID"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import WellsSearch from './wells/Wells.vue';
import WellsSearchResult from './wells/wellsResult.vue';

export default {
  name: 'Search',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    WellsSearch,
    WellsSearchResult,
  },
  data() {
    return {
      type: ws_vue_store.config.search,
      searchTerm: this.$route.query.search_term,
      searchClosed: true,
      searchError: false,
      translations: {
        noProductsMatch: ws_vue_store.translations.no_products_match,
      },
    };
  },
  watch: {
    searchTerm(val, oldVal) {
      //if(val == oldVal) return;
      this.getFilteredResults();
      this.searchClosed = !val.length;
      if (val.length < 3) {
        this.searchClosed = true;
      }
    },
  },
  computed: {
    filteredResults() {
      if (this.type === 'wells') {
        return this.$store.getters.getSearchedProducts;
      }

      return [];
    },
  }, // computed
  methods: {
    getFilteredResults() {
      // match keyword against post titles or excerpts.
      if (this.searchTerm === '' || this.searchTerm.length < 3) {
        return [];
      }

      this.$store
        .dispatch('searchProducts', { keyword: this.searchTerm })
        .then(() => {
          if (this.$store.getters.getSearchedProducts.length === 0) {
            this.searchError = true;
          } else {
            this.searchError = false;
          }
        });
    },
    setSearchError(isError) {
      this.searchError = isError;
    },
    highlight(data) {
      if (this.searchTerm) {
        const pattern = new RegExp(this.searchTerm, 'i');
        const foundIndex = data
          .toLowerCase()
          .indexOf(this.searchTerm.toLowerCase());
        if (foundIndex === -1) {
          return '';
        }
        const maxLength = 50;
        const startIndex = foundIndex - 15 > 0 ? foundIndex - 15 : 0;
        // debugger
        const highlightedArea = data.substring(
          startIndex,
          startIndex + maxLength
        );
        const highlightedData = highlightedArea.replace(
          pattern,
          `<span class="highlight">${data.substring(
            foundIndex,
            foundIndex + this.searchTerm.length
          )}</span>`
        );
        return highlightedData;
      }
      return '';
    },
    closeSearch() {
      this.searchClosed = true;
    },
    escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search {
  position: relative;
  width: 100%;
  border: 0.1rem solid transparent;

  @include small {
    width: 100%;
  }
  &__results {
    position: absolute;
    right: 0;
    left: 0;
    z-index: 9999;
    max-height: 16.5rem;
    max-height: calc(100vh - 40rem);
    overflow: auto;
    background-color: $color-white;
    box-shadow: 0px 1rem 1rem 0px rgba(0, 0, 0, 0.15);

    .scroll-area {
      position: relative;
      height: 100%;
      margin: auto;
    }

    h3 {
      color: #c1c1c1;
      font-size: 1.6rem;
      line-height: 2.9rem;

      .highlight {
        color: $color-text;
      }
    }
  }
}
</style>
